import React, {useState} from 'react';
import './login.scss';
import Button from '../Form/Button/Button';
import {useCurrentUser} from '../../contexts/CurrentUserProvider';
import {useLogger} from '../../contexts/Logger';

const Logout = () => {
  const currentUser = useCurrentUser();
  const logger = useLogger();

  if (currentUser && currentUser.isAuthenticated && currentUser.logout) {
      logger.info(`Calling logout from logout page`);
      currentUser.logout();
      return null;
  }
  // sessionStorage.removeItem("maturity_popup_dismissed");
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith("app-accepted-")) {
        sessionStorage.removeItem(key);
    }
  });

  const [isTabletOrAbove, setIsTabletOrAbove] = useState(window.innerWidth >= 768);

  return (
    <div className="login logout" style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isTabletOrAbove ? '140px 0' : undefined,
    }}
    >
      <h1 className="login__title login__title--margin-top">You have successfully logged out.</h1>
      <div className="login__line">We look forward to seeing you again soon.</div>
      <div className="login__line login__margin">Would you like to log back in?</div>
      <Button customClassNames={["login__button"]} label="Log in" onClick={() => window.location.href = "/"} />
  </div>
  )
};

export default Logout;
